import React, {useMemo} from "react";
import {DetailEntityShell} from "./DetailEditContext";
import {DetailProgressStatus} from "./DetailProgressStatus";
import {DetailRollupActions} from "./DetailRollupActions";

/**
 * 유지보수·서비스요청 등 콘텐츠 상세 본문 — AssetDepreciation / AssetInfo와 동일 골격
 */
export function ContentDetailInfoShell({
    title,
    meta,
    canUpdate = false,
    listUrl,
    actions,
    rollup,
    className = "",
    contentId,
    contentCategory,
    topContent: topContentProp,
    scrollMode = "stack",
    trackActions = false,
    children,
}) {
    const topContent = topContentProp ?? (contentId != null && contentCategory
        ? <DetailProgressStatus contentId={contentId} contentCategory={contentCategory} />
        : null);

    const rollupActions = useMemo(() => (
        rollup ? <DetailRollupActions {...rollup} /> : null
    ), [rollup?.create, rollup?.update, rollup?.remove, rollup?.movePage, rollup?.updateTitle, rollup?.createTitle, rollup?.cancel, rollup?.data]);

    return (
        <div className="asset-view-tab-panel detail-view-tab-panel flex min-h-0 min-w-0 flex-1 flex-col w-full overflow-hidden">
            <DetailEntityShell
                title={title}
                meta={meta}
                canUpdate={canUpdate}
                listUrl={listUrl}
                actions={actions}
                rollupActions={rollupActions}
                topContent={topContent}
                scrollMode={scrollMode}
                trackActions={trackActions}
                className={`flex min-h-0 flex-1 flex-col ${className}`.trim()}
            >
                {children}
            </DetailEntityShell>
        </div>
    );
}
